import VSS = require("VSS/VSS");
import VSS_Service = require("VSS/Service");
import Contribution_Services = require("VSS/Contributions/Services");
import SDK_Shim = require("VSS/SDK/Shim");
import Context = require("VSS/Context");
import ServerConstants = require("Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants");

import VCCreateBranchWithLinkedWorkItems_Async = require("VersionControl/Scripts/CreateBranchWithLinkedWorkItems");

(function () {
    const shortContributionIds = ["create-branch-menu", "create-branch-work-item-menu"];
    const contributionPrefix = "ms.vss-code-web.";
    const supportsGitContributionId = "ms.vss-code-web.supports-git-data-provider";

    let contribution = VSS_Service.getService(Contribution_Services.WebPageDataService).getPageData(supportsGitContributionId);
    let isGitSupported = contribution && contribution["isSupported"];

    if (isGitSupported) {
        shortContributionIds.forEach((id) => {
            SDK_Shim.VSS.register(id, { execute: onCreateBranchMenuItemClick });
            SDK_Shim.VSS.register(contributionPrefix + id, { execute: onCreateBranchMenuItemClick });
        });
    }
})();

export function onCreateBranchMenuItemClick(actionContext: any): void {
    let pageContext = Context.getPageContext();

    // extract selected work item ids depending on which contribution point
    let workItemIds =
        actionContext.ids || // work items on queries view
        actionContext.workItemIds || // work items on backlog view
        (actionContext.workItemAvailable && actionContext.workItemId && [actionContext.workItemId]) || // work item toolbar
        (actionContext.id && [actionContext.id]); // work items on board view

    let contributionPoint = actionContext.workItemAvailable ? "item." : "";
    contributionPoint += pageContext.navigation.currentController + "." + pageContext.navigation.currentAction;

    VSS.requireModules(["VersionControl/Scripts/CreateBranchWithLinkedWorkItems"]).spread(
        (VCCreateBranchWithLinkedWorkItems: typeof VCCreateBranchWithLinkedWorkItems_Async) => {
            VCCreateBranchWithLinkedWorkItems.openCreateBranchDialog(
                workItemIds,
                contributionPoint,
                actionContext.currentProjectName,
                actionContext.currentProjectGuid,
                actionContext.movedToNewProject
            );
        }
    );
}

VSS.tfsModuleLoaded("TFS.VersionControl.CreateBranchContextMenu", exports);
